import React, { useMemo } from "react";

import { IUserLoyaltyProgram } from "Bands/types";
import { TeaserProps } from "shared/components";
import { DocumentTeaser } from "./DocumentTeaser";

interface PassportTeaserProps extends IUserLoyaltyProgram, TeaserProps {}

export const LoyaltyProgramTeaser: React.FC<PassportTeaserProps> = ({
  programName,
  programFamily,
  issuingCompany,
  ...rest
}) => {
  const subTitle = useMemo(() => {
    let title = "";

    if (programFamily) title = programFamily;
    if (issuingCompany) title += `${programFamily && " - "}Issued by ${issuingCompany}`;

    return title;
  }, [programFamily, issuingCompany]);
  return <DocumentTeaser {...rest} title={programName} subTitle={subTitle} />;
};
